var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('prompt-manager',{attrs:{"title":"Prompts (Tout AIF)","prefixes":['AIF'],"default-new-template-prefix":"AIF "}})}
var staticRenderFns = []

export { render, staticRenderFns }